import React, { useCallback } from 'react';
import { Box, CheckBox, Inscription } from '@common-fe/common-fe';

import { Service } from '@/modules/plan/PlanSetup/EligibleServicesSection/EligibleServices.types.ts';
import theme from '@/styles/theme';

import TableItemWrapper from '../../TableItemWrapper';

interface Props {
  service: Service;
  isChecked: boolean;
  isDisabled?: boolean;
  onSelect: (categoryId: string) => void;
}

const ServiceItem: React.FC<Props> = ({
  service,
  isChecked,
  isDisabled,
  onSelect,
}) => {
  const handleClick = useCallback(() => {
    if (!isDisabled) {
      onSelect(service?.id);
    }
  }, [isDisabled, onSelect, service?.id]);
  return (
    <TableItemWrapper
      isChecked={isChecked}
    >
      <Box
        data-testid="service-item"
        direction="row"
        align="center"
        style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
        onClick={handleClick}
      >
        <Box direction="row" align="center" width="50%">
          <CheckBox
            name={service?.id}
            checked={isChecked}
            disabled={isDisabled}
          />
          <Inscription style={{ marginLeft: theme.spacings.m }} lineHeight="20px" color="textBody" weight="bold">
            {service?.name}
          </Inscription>
        </Box>
        <Box width="50%">
          <Inscription lineHeight="20px" color="textBody">
            {service?.type}
          </Inscription>
        </Box>
      </Box>
    </TableItemWrapper>
  );
};

export default ServiceItem;
